import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../urunDiv.css';
import lalika from '../../../../assets/menu/icecekler/kokteyller/lalika.jpeg';
import coolLimeCilekli from '../../../../assets/menu/icecekler/kokteyller/cool-lime-cilekli.jpeg';
import coolLimeMentollu from '../../../../assets/menu/icecekler/kokteyller/cool-lime-mentollu.jpeg';
import sangria from '../../../../assets/menu/icecekler/kokteyller/sangria.jpeg';
import blueLagoon from '../../../../assets/menu/icecekler/kokteyller/blue-lagoon.jpeg';
import blueHawai from '../../../../assets/menu/icecekler/kokteyller/blue-hawai.jpeg';
import berryHibiscus from '../../../../assets/menu/icecekler/kokteyller/berry-hibiscus.jpeg';


const Kokteyller = () => {
  const [selectedKahve, setSelectedKahve] = useState(null);
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const kahveKategorileri = {
    'Kokteyller': [
      {
        id: 1,
        name: 'Lalika',
        price: '₺249.90',
        image: lalika
      },
      {
        id: 2,
        name: 'Cool Lime Çilekli',
        price: '₺249.90',
        image: coolLimeCilekli
      },
      {
        id: 3,
        name: 'Cool Lime Mentollü',
        price: '₺249.90',
        image: coolLimeMentollu
      },
      {
        id: 4,
        name: 'Sangria',
        price: '₺249.90',
        image: sangria
      },
      {
        id: 5,
        name: 'Blue Lagoon',
        price: '₺249.90',
        image: blueLagoon
      },
      {
        id: 6,
        name: 'Blue Hawai',
        price: '₺249.90',
        image: blueHawai
      },
      {
        id: 7,
        name: 'Berry Hibiscus',
        price: '₺249.90',
        image: berryHibiscus
      }
    ]
  };

  const handleKahveClick = (kahve) => {
    if (kahve.name === 'Lalika') {
      navigate('/kokteyller/lalika');
    } else if (kahve.name === 'Cool Lime Çilekli') {
      navigate('/kokteyller/cool-lime-cilekli');
    } else if (kahve.name === 'Cool Lime Mentollü') {
      navigate('/kokteyller/cool-lime-mentollu');
    } else if (kahve.name === 'Sangria') {
      navigate('/kokteyller/sangria');
    } else if (kahve.name === 'Blue Lagoon') {
      navigate('/kokteyller/blue-lagoon');
    } else if (kahve.name === 'Blue Hawai') {
      navigate('/kokteyller/blue-hawai');
    } else if (kahve.name === 'Berry Hibiscus') {
      navigate('/kokteyller/berry-hibiscus');
    } else {
      setSelectedKahve(kahve);
    }
  };

  const handleBackToMenu = () => {
    setSelectedKahve(null);
  };

  if (selectedKahve) {
    return <KahveDetay kahve={selectedKahve} onBack={handleBackToMenu} />;
  }

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Kokteyller</h2>
        </div>
        
        {Object.entries(kahveKategorileri).map(([kategori, kahveler]) => (
          <div key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid">
              {kahveler.map((kahve) => (
                <div 
                  key={kahve.id} 
                  className="urun-kart"
                  onClick={() => handleKahveClick(kahve)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad">{kahve.name}</h3>
                    <div className="urun-fiyat">{kahve.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={kahve.image} alt={kahve.name} style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Kokteyller</h2>
        </div>
        
        {Object.entries(kahveKategorileri).map(([kategori, kahveler]) => (
          <div style={{marginBottom: '80px'}} key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid-computer">
              {kahveler.map((kahve) => (
                <div 
                  key={kahve.id} 
                  className="urun-kart-computer"
                  onClick={() => handleKahveClick(kahve)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad-computer">{kahve.name}</h3>
                    <div className="urun-fiyat-computer">{kahve.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={kahve.image} alt={kahve.name} style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default Kokteyller;
